<template>
  <div
    class="left-menu-container"
    :class="{
      'scrollbar-wrapper': true,
      isCollapse: isCollapse,
      ignoreSecondMenu: ignoreSecondMenu,
    }"
    @mouseleave="handleItemLeave"
  >
    <Hamburger
      v-show="showSecondMenu && menuActived"
      :toggle-click="toggleSideBar"
      :is-active="sidebar.opened"
      class="hamburger-container"
    />
    <div class="scrollbar-left">
      <el-menu
        class="left-menu"
        :collapse="isCollapse"
        :default-active="pathname"
        text-color="#fff"
        :hide-timeout="0"
        :show-timeout="0"
        :collapse-transition="false"
        active-text-color="#2E8FF1"
        style="border: 0"
      >
        <slot name="firstMenuTop"></slot>
        <el-menu-item
          :index="item.key"
          v-for="(item, i) in menuList"
          :key="item.key"
          @click="toOther(item.key)"
          @mouseover.native="handleItemHover(item, i)"
          @mouseleave.native="handleItemMouseLeave"
          :class="{ 'hover-active': i == hoverActive }"
        >
          <a v-if="item.error || !item.icon">
            <div class="icon"><i class="el-icon-menu"></i></div>
            <div slot="title" class="name">
              {{ item.abbreviation || item.name }}
            </div>
          </a>
          <a
            @mouseover.stop="handleItemHover(item, i)"
            @mouseleave.stop="handleItemMouseLeave"
            :href="computedItemHref(item.key)"
            @click.prevent="()=>{}"
            v-else
          >
            <div class="icon">
              <!-- 在store的permission文件里getMenuFun方法中有关于icon名字的处理 -->
              <svg-icon
                :icon-class="item.icon"
                class="multicolor-icon menu-icon"
              ></svg-icon>
              <svg-icon
                :icon-class="item.activeIcon"
                class="multicolor-icon active-menu-icon"
              ></svg-icon>
            </div>
            <!-- 为了关闭tooltip -->
            <div slot="title" class="name">
              {{ item.abbreviation || item.name }}
            </div>
          </a>
        </el-menu-item>
        <slot name="firstMenuBottom"></slot>
      </el-menu>

      <!-- hover二级菜单 -->
      <div
        class="scrollbar-right hover-bar"
        :class="{ 'hide-hover-bar': !hoverMenuShow }"
        @mouseover="secondMenuHover"
      >
        <div class="project-name" @click="foldChange('hover')">
          <i :class="curMenuUnfold ? 'QS-icon-unfold' : 'QS-icon-fold'"></i>
          <span>{{ curMenuUnfold ? '全部收起' : '全部展开' }}</span>
        </div>
        <custom-menu
          :menuList="subMenuList"
          :canCollapse="false"
          :containerId="'hoverSecondMenuContainer'"
          :scrollBoxId="'hoverSecondMenuScrollBox'"
          :default-openeds="hoverMenuOpenKeys"
          bgColor="#F4F8FF"
          @openSubmenuKey="openSubmenuKey($event, 'hover')"
          @closeSubmenuKey="closeSubmenuKey($event, 'hover')"
        >
          <template slot="secondMenu">
            <slot name="hoverSecondMenu"></slot>
          </template>
        </custom-menu>
      </div>
    </div>

    <div
      class="scrollbar-right"
      :class="{ 'hide-second-menu': isCollapse || ignoreSecondMenu }"
      @mouseover="secondMenuHover"
    >
      <div class="project-name" id="second-menu-fold-area" @click="foldChange">
        <i :class="curMenuUnfold ? 'QS-icon-unfold' : 'QS-icon-fold'"></i>
        <span>{{ curMenuUnfold ? '全部收起' : '全部展开' }}</span>
      </div>
      <custom-menu
        :menuList="subMenuList"
        :canCollapse="true"
        :containerId="'secondMenuContainer'"
        :scrollBoxId="'secondMenuScrollBox'"
        :default-openeds="menuOpenKeys"
        bgColor="#FFFFFF"
        @openSubmenuKey="openSubmenuKey"
        @closeSubmenuKey="closeSubmenuKey"
      >
        <template slot="secondMenuTop">
          <slot name="secondMenuTop"></slot>
        </template>
        <template slot="secondMenu">
          <slot name="secondMenu"></slot>
        </template>
        <template slot="secondMenuBottom">
          <slot name="secondMenuBottom"></slot>
        </template>
      </custom-menu>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import customMenu from '../custom-menu'
import svgIcon from '../../../svg-icon/main.vue'
import Hamburger from './components/Hamburger'

export default {
  name: 'LeftMenuNew',
  components: { Hamburger, customMenu, svgIcon },
  props: [
    'ignoreSecondMenu',
    'hoverSubmenuKey',
    'submenuKey',
    'showSecondMenu',
  ],
  data() {
    return {
      pathname: '',
      scrollBarKey: '',
      hoverActive: null,
      hoverOverTimer: null, // 菜单hover时间定时器
      // 二级菜单展开状态
      menuUnfoldStatus: {},
      hoverMenuOpenKeys: [],
      menuOpenKeys: [],
    }
  },
  computed: {
    ...mapGetters([
      'subMenuList',
      'menuList', // 左侧一级主菜单
      'sidebar',
      'hoverMenuShow',
    ]),
    isCollapse() {
      return !this.sidebar.opened
    },
    curMenuUnfold() {
      return this.projectName && !!this.menuUnfoldStatus[this.projectName]
    },
    projectName() {
      // 如果有hover二级菜单名称展示hover名称
      if (
        this.$store.state.app.hoverItem &&
        this.$store.state.app.hoverItem.name &&
        this.hoverMenuShow
      ) {
        return this.$store.state.app.hoverItem.name
      }
      if (this.menuList && this.menuList.length && this.pathname) {
        const cur = this.menuList.find((item) => item.key === this.pathname)
        if (cur) return cur.name
      }
      return ''
    },
    computedItemHref() {
      return function (key) {
        const exclude = ['legend', 'tool']
        if (window.__POWERED_BY_QIANKUN__ && !exclude.includes(key)) {
          return `/${key}/welcome`
        }
        return `${window.location.origin}/${key}`
      }
    },
    menuActived() {
      return (
        this.menuList &&
        this.menuList.find((item) => item.key === this.pathname)
      )
    },
  },
  methods: {
    ...mapActions(['changeMenu']),
    openSubmenuKey(key, mode) {
      const keysArr =
        mode === 'hover' ? this.hoverMenuOpenKeys : this.menuOpenKeys
      if (key && keysArr.indexOf(key) < 0) {
        keysArr.push(key)
      }
    },
    closeSubmenuKey(key, mode) {
      const keysArr =
        mode === 'hover' ? this.hoverMenuOpenKeys : this.menuOpenKeys
      keysArr.filter((item) => item !== key)
    },
    foldChange(mode) {
      if (this.projectName) {
        this.$set(
          this.menuUnfoldStatus,
          this.projectName,
          !this.menuUnfoldStatus[this.projectName],
        )
        if (this.curMenuUnfold) {
          if (mode === 'hover') this.hoverMenuOpenKeys = this.hoverSubmenuKey
          else this.menuOpenKeys = this.submenuKey
        } else if (mode === 'hover') this.hoverMenuOpenKeys = []
        else this.menuOpenKeys = []
      }
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    async toOther(key) {
      // 菜单切换，清除车辆管理页面的筛选条件缓存
      this.dataBase.deleteAll()
      if (key === this.pathname) {
        if (!this.sidebar.opened) {
          this.$store.dispatch('ToggleSideBar')
        }
        return
      }
      this.pathname = key
      this.changeMenu({
        platformName: key,
      })
      this.$router.push(`/${key}`)
    },
    handleItemHover(menuItem, index) {
      clearInterval(this.hoverOverTimer)
      let overtime = 0
      const hoverOverTimeConst = 100
      this.hoverOverTimer = setInterval(() => {
        overtime += hoverOverTimeConst
        if (overtime > 200) {
          this._handleItemHover(menuItem, index)
          clearInterval(this.hoverOverTimer)
        }
      }, hoverOverTimeConst)
    },
    _handleItemHover(menuItem, index) {
      // 一级菜单hover
      this.hoverActive = index
      if (menuItem.key === this.pathname && !this.isCollapse) {
        // 当前子应用且未collapse 显示原本的菜单
        this.$store.commit('SET_HOVER_MENU_SHOW', false)
      }
      this.scrollBarKey = menuItem.key
    },
    handleItemMouseLeave() {
      clearInterval(this.hoverOverTimer)
    },
    secondMenuHover() {
      if (!this.$store.state.app.hoverItem) {
        // 类工作台 鼠标移入二级菜单取消hover态
        this.hoverActive = null
      }
    },
    handleItemLeave() {
      // 重置一级菜单hover
      this.hoverActive = null
      this.$store.commit('SET_HOVER_MENU_SHOW', false)
    },
  },
  mounted() {
    this.pathname = this.$route.matched[0]?.name || this.menuList[0]?.key
    this.changeMenu({
      platformName: this.pathname,
    })
  },
  watch: {
    $route: {
      handler(val) {
        // 跟随路由变化 切换路由平台
        this.pathname = val.matched[0]?.name
        this.changeMenu({
          platformName: this.pathname,
        })
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.left-menu-container {
  position: relative;
  .hamburger-container {
    position: absolute;
    top: 50%;
    right: -12px;
    z-index: 9;
  }

  .common-menu {
    width: 100%;
    // height: calc(100vh - 56px - 40px);
    flex: 1;
    background: #fff;
    position: relative;
    overflow: hidden;
    ::-webkit-scrollbar {
      width: 4px !important;
      background: transparent !important;
    }
    .common-menu-loading {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 99;
      background: #fff;
    }

    ::-webkit-scrollbar,
    ::-webkit-scrollbar-track {
      width: 4px !important;
      background: transparent !important;
    }
    ::-webkit-scrollbar-thumb {
      width: 4px !important;
      background: transparent !important;
    }
    &:hover {
      ::-webkit-scrollbar-thumb {
        width: 4px !important;
        background: rgba(0, 0, 0, 0.1) !important;
      }
    }
  }
}

#app .hideSidebar .sidebar-container {
  width: 80px !important;
}
#app .scrollbar-wrapper {
  display: flex;
  background: #fff;
}

::-webkit-scrollbar,
::-webkit-scrollbar-thumb,
::-webkit-scrollbar-track {
  width: 0 !important;
  background-color: rgba(0, 0, 0, 0);
}

.left-menu-container.scrollbar-wrapper .scrollbar-right {
  display: flex;
  flex-direction: column;
  width: 168px !important;
  z-index: 1;
  box-shadow: 4px 0px 4px 0px rgba(0, 0, 0, 0.04) !important;
  overflow: hidden;
  &.hide-hover-bar,
  &.hide-second-menu {
    width: 0px !important;
  }
}
</style>

<style lang="scss">
$--border-radius-large: 8px;
$--font-size-medium: 16px;
$--font-size-extra-small: 12px;
$--color-main: #276bec;
$--color-white: #fff;
$--color-aside-bg-start: #1b59dc;
$--color-aside-bg-middle: #2171e7;
$--color-aside-bg-end: #1f8aed;
$--color-aside-menu-item-hover-bg: #f4f8ff;
$--border-radius-menu-item: $--border-radius-large;
$--color-text-secondary: rgba(0, 0, 0, 0.45);
$-hover-bar-index: 2001;
$--color-primary-light-B4-1: #5087ed;

.left-menu-container {
  .left-menu {
    flex: 1;
    overflow: auto;
    box-sizing: border-box;
    padding-left: 4px;
    padding-right: 0px;
    scrollbar-width: none; /* Firefox 64 去掉滚动条样式*/
    .el-menu-item {
      padding: 8px 0 !important;
      margin-bottom: 6px;
      height: 60px;
      border-top-left-radius: $--border-radius-menu-item !important;
      border-bottom-left-radius: $--border-radius-menu-item !important;
      position: relative;
      transition: none;
      .icon,
      .name {
        display: block;
        width: 100%;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: $--color-white;
        z-index: 1;
        position: relative;
      }
      .icon {
        height: 24px;
      }
      .name {
        color: $--color-white;
        height: 20px;
        line-height: 20px;
        font-size: $--font-size-extra-small;
        transition: color 0.2s;
      }
      .icon .multicolor-icon {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        font-size: 24px;
        line-height: 1;
        transition: opacity 0.2s;
      }
      .active-menu-icon {
        opacity: 0;
      }
      &::after {
        opacity: 0;
        content: '';
        position: absolute;
        z-index: 0;
        top: -6px;
        left: 0;
        width: 77px;
        height: 72px;
        background-image: url('../../assets/menu_bg.png');
        background-repeat: no-repeat;
        background-position: 0 0;
        transition: opacity 0.2s;
      }
      &.hover-active,
      &:hover {
        background: transparent;
        .name {
          font-weight: 500 !important;
        }
        &::after {
          opacity: 0.25;
        }
      }
      &:visited,
      &:active,
      &.is-active,
      &.is-active:hover {
        .icon i,
        .name {
          color: $--color-primary-light-B4-1 !important;
          font-weight: 500 !important;
        }
        .active-menu-icon {
          opacity: 1 !important;
        }
        .menu-icon {
          opacity: 0 !important;
        }
        &::after {
          opacity: 1 !important;
        }
      }
    }
  }
  .hover-bar .project-name {
    background-color: $--color-aside-menu-item-hover-bg !important;
  }
  .scrollbar-right.hover-bar {
    // 一级菜单hover栏
    position: absolute;
    z-index: $-hover-bar-index !important;
    top: 0;
    left: 100%;
    box-shadow: 4px 0px 4px 0px rgba(0, 0, 0, 0.1) !important;
    height: calc(100vh - 48px);
    display: flex;
    flex-direction: column;
    transition: all 0.2s ease-in-out;
    .scorll-container {
      flex: 1;
      overflow: hidden;
    }
  }

  .scrollbar-left {
    position: relative;
    display: flex;
    flex-direction: column;
    padding-top: 20px;
    background: $--color-aside-bg-start;

    &::after {
      content: '';
      position: absolute;
      z-index: $-hover-bar-index + 1;
      background: transparent;
      bottom: 0px;
      right: -8px;
      width: 8px;
      height: 8px;
      border-bottom-left-radius: $--border-radius-menu-item !important;
    }

    //一级菜单底部留取空间
    > .el-menu {
      width: 80px !important;
      padding-top: 8px;
      overflow-x: hidden;
      padding-bottom: 20px;
      background: linear-gradient(
        180deg,
        $--color-aside-bg-start 0%,
        $--color-aside-bg-middle 72%,
        $--color-aside-bg-end 100%
      );
    }
    // 子应用加载透明遮罩
    .scrollbar-left-mask {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 9;
    }
  }

  &.scrollbar-wrapper .scrollbar-right .project-name {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    height: 38px;
    font-size: $--font-size-extra-small;
    color: #9e9e9e;
    background-color: #fff;
    cursor: pointer;
    z-index: 1;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08) !important;
    i {
      font-size: $--font-size-medium;
      color: $--color-text-secondary;
    }
    span {
      flex-shrink: 0;
    }
    &:hover {
      i,
      span {
        color: $--color-main;
      }
    }
  }
  // 底部搜索/反馈
  .bottom-bar {
    width: 100%;
    height: 40px;
    background-color: #9edefd;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: $-hover-bar-index + 9;
    .left-menu-icon {
      font-size: 20px;
      color: #2c96ca;
      cursor: pointer;
    }
  }
  .scrollbar-right .sidebar-el-menu {
    position: relative;
    overflow-y: scroll;
    top: 0px !important;
    height: 100%;
    overflow-x: hidden !important;
    bottom: 0;
    padding: 8px 2px 16px 8px !important;
    box-sizing: border-box;
    scrollbar-width: none; /* Firefox 64 去掉滚动条样式*/
  }
}

#app .hideSidebar .left-menu .el-menu-item .el-tooltip {
  padding-left: 0px !important;
}
</style>
